import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
function FormSection({ title, description, children }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
        className: "mt-12 grid grid-cols-1 gap-x-8 gap-y-10 border-b border-border pb-12 last:border-b-0 md:grid-cols-3",
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("h2", {
                        className: "text-base font-semibold leading-7",
                        children: title
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                        className: "mt-1 text-sm leading-6 text-muted-foreground",
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                className: "grid w-full grid-cols-6 gap-x-6 gap-y-8 md:col-span-2",
                children: children
            })
        ]
    });
}
export { FormSection };

//# sourceMappingURL=index.js.map